import { Check, X } from 'lucide-react';
import { Card } from '@/components/ui/card';

const ComparisonTable = () => {
  const features = [
    {
      feature: "Talent Database Access",
      free: false,
      starter: true
    },
    {
      feature: "Tech Profile Unlocks",
      subtext: "(Software Engineering, Data Science, QA)",
      free: "3",
      starter: "25"
    },
    {
      feature: "Non-Tech Profile Unlocks",
      subtext: "(Design, Sales, Marketing, HR)",
      free: "Unlimited (strict fair usage policy)",
      starter: "Unlimited (relaxed fair usage policy)"
    },
    {
      feature: "Job Visibility",
      free: "Low",
      starter: "High"
    },
    {
      feature: "Team Members Included",
      free: "3",
      starter: "5"
    }
  ];

  return (
    <section className="py-16 bg-secondary">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-foreground mb-4">
            Say good-bye to frustrating limits of the Free plan
          </h2>
        </div>

        <div className="max-w-4xl mx-auto">
          <Card className="overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-border">
                    <th className="text-left py-4 px-6 font-semibold text-foreground">Feature</th>
                    <th className="text-center py-4 px-6 font-semibold text-foreground">Free Plan</th>
                    <th className="text-center py-4 px-6 font-semibold text-foreground bg-primary/5 border-l-2 border-primary">
                      Starter Plan
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {features.map((row, index) => (
                    <tr key={index} className="border-b border-border last:border-b-0">
                      <td className="py-4 px-6">
                        <div>
                          <div className="font-medium text-foreground">{row.feature}</div>
                          {row.subtext && (
                            <div className="text-sm text-muted-foreground">{row.subtext}</div>
                          )}
                        </div>
                      </td>
                      <td className="py-4 px-6 text-center">
                        {typeof row.free === 'boolean' ? (
                          row.free ? (
                            <Check className="w-5 h-5 text-green-600 mx-auto" />
                          ) : (
                            <X className="w-5 h-5 text-red-500 mx-auto" />
                          )
                        ) : (
                          <span className="text-foreground font-medium">{row.free}</span>
                        )}
                      </td>
                      <td className="py-4 px-6 text-center bg-primary/5">
                        {typeof row.starter === 'boolean' ? (
                          row.starter ? (
                            <Check className="w-5 h-5 text-green-600 mx-auto" />
                          ) : (
                            <X className="w-5 h-5 text-red-500 mx-auto" />
                          )
                        ) : (
                          <span className="text-foreground font-bold">{row.starter}</span>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Card>

        </div>
      </div>
    </section>
  );
};

export default ComparisonTable;


